// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, Link, useParams } from '@tanstack/react-router';

// material ui
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer',
)({
  component: RouteComponent,
  staticData: { crumb: 'service-manager:services.energyxplorer.title' },
});

function RouteComponent() {
  const { t } = useTranslation('service-manager');
  const { managedAccountId } = useParams({
    from: '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer',
  });

  return (
    <Stack spacing={2}>
      <Card>
        <CardHeader
          title={t('services.energyxplorer.title')}
          action={
            <ServiceActivationSwitch
              managedAccountId={managedAccountId}
              servicePath="energyxplorer"
              ariaLabel={t('services.energyxplorer.title')}
            />
          }
          slotProps={{
            title: { variant: 'h6', fontWeight: 600 }
          }}
        />
        <Divider />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {t('services.energyxplorer.description')}
          </Typography>
        </CardContent>
        <Divider />
        <CardActions sx={{ justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            component={Link}
            to={`/${managedAccountId}/operations/deep-dive`}
            size="small"
            color="primary"
            disableElevation
            sx={{
              ':hover': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
              },
            }}
          >
            {t('portfolioAnalysis.operationalStatus')}
          </Button>
        </CardActions>
      </Card>
    </Stack>
  );
}
